var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.17 0h-7.4A2.77 2.77 0 0 0 0 2.77v14.46A2.77 2.77 0 0 0 2.77 20h7.4a2.77 2.77 0 0 0 2.77-2.77V2.77A2.77 2.77 0 0 0 10.17 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.42 4.64a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24"
  })));
};
export default SvgDevices;